import { IconClose } from "@/assets/images/Icons";
import ImageGeneric from "@/assets/images/lg.png";
import { useLayout } from "../../contexts/UseLayout";
import { UserGoOn } from "./UserGoOn";
import DropdownButton from "../Header/DropdownButton";

export function MobileMenu({ togleModal }: any) {
  const context = useLayout();
  const userIsAdmin = context?.userLogged?.data?.is_admin;
  const userLogado = context?.userLogged?.data;
  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center overflow-x-hidden overflow-y-auto outline-none focus:outline-none">
      <div className="relative w-[95%] h-[95%] mx-auto my-6">
        <div className="relative bg-white p-6 rounded-lg shadow-md z-50">
          <button
            className="absolute top-0 right-0 mt-4 mr-4 text-gray-600 cursor-pointer"
            onClick={() => togleModal(false)}
          >
            <IconClose />
          </button>

          <div className="bg-white rounded-t-2xl gap-4 flex flex-col justify-between">
            <div className="flex flex-col items-center">
              <img
                className="rounded-full"
                src={userLogado.filePath ? userLogado.filePath : ImageGeneric}
                alt={userLogado.name}
                width={132}
              />
              <div className="flex flex-col text-center">
                <span className="text-cinza-300">{userLogado?.cargoNome}</span>
                <div className="flex items-center gap-2">
                  <span className="text-lg font-medium ">
                    {userLogado?.name}
                  </span>
                  <DropdownButton />
                </div>
              </div>
            </div>

            <nav className="font-medium">
              <ul className="text-cinza-200 px-4 flex flex-col gap-1 text-sm">
                <UserGoOn is_admin={userIsAdmin} isExpanded={true} />
              </ul>
            </nav>
            <div className="mx-auto">
              <svg
                viewBox="0 0 490 74"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
                className="w-[60%]"
              >
                <g clipPath="url(#clip0_7384_262)">
                  <path
                    d="M61.5928 58.0593H29.9112L33.9526 48.6615H57.5454L40.1697 7.94586L11.8739 74H0L28.6475 7.06366C29.6608 3.84734 32.2359 0 35.6693 0H44.6641C48.4552 0 50.3746 3.94536 51.6382 7.06366C70.7366 51.7246 61.1874 29.3942 80.2858 74H68.4119L61.5928 58.0593Z"
                    fill="#D2D2D2"
                  />
                  <path
                    d="M87.8619 21.289C87.8619 9.55096 97.1608 0 108.528 0H124.497C143.947 0 157.841 16.5166 157.841 36.0902V37.9098C157.841 57.5385 143.947 74 124.497 74H87.8679V21.289H87.8619ZM98.7284 64.3388H122.125C136.979 64.3388 146.629 51.7185 146.629 36.9724C146.629 22.2263 136.979 9.66123 122.125 9.66123H98.7284V64.3388Z"
                    fill="#D2D2D2"
                  />
                  <path
                    d="M199.107 21.289C199.107 9.55096 208.405 0 219.773 0H235.742C255.192 0 269.086 16.5166 269.086 36.0902V37.9098C269.086 57.5385 255.192 74 235.742 74H199.113V21.289H199.107ZM209.973 64.3388H233.369C248.223 64.3388 257.874 51.7185 257.874 36.9724C257.874 22.2263 248.223 9.66123 233.369 9.66123H209.973V64.3388Z"
                    fill="#D2D2D2"
                  />
                  <path
                    d="M342.716 9.66123H316.238C301.688 9.66123 289.76 21.969 289.76 36.9724C289.76 51.9758 301.682 64.3388 316.238 64.3388H344.987L342.716 74H313.865C294.618 74 278.852 57.7468 278.852 37.9098V36.0902C278.852 16.2532 294.618 0 313.865 0H344.987L342.716 9.66123ZM340.391 41.8551H302.093L304.316 32.1449H340.391V41.8551Z"
                    fill="#D2D2D2"
                  />
                  <path
                    d="M356.36 64.3388H396.929C403.248 64.3388 408.398 58.9905 408.398 52.4966C408.398 46.0026 403.194 40.9178 396.929 40.9178H374.499C363.638 40.9178 354.792 31.4649 354.792 20.3027C354.792 9.14049 363.632 0 374.499 0H416.028V9.66123H376.418C370.505 9.66123 365.659 14.6481 365.659 20.7744C365.659 26.9007 370.559 31.6241 376.418 31.6241H398.902C410.168 31.6241 419.312 41.3895 419.312 52.9683C419.312 64.5471 410.114 74 398.902 74H354.089L356.36 64.3388Z"
                    fill="#D2D2D2"
                  />
                  <path
                    d="M466.05 28.6161C462.36 33.0822 461.704 33.2905 458.521 35.4163C463.874 37.2359 464.989 38.2222 468.577 43.4112L489.946 73.9939H476.356L452.405 39.7232H436.24V73.9939H425.379V0H436.24V31.1034H450.438L476.457 0H490L466.05 28.6161Z"
                    fill="#D2D2D2"
                  />
                </g>
                <defs>
                  <clipPath id="clip0_7384_262">
                    <rect width="490" height="74" fill="white" />
                  </clipPath>
                </defs>
              </svg>
            </div>
          </div>
        </div>
      </div>
      <div
        className="fixed inset-0 bg-black opacity-50"
        onClick={() => togleModal(false)}
      />
    </div>
  );
}
